module.exports = __webpack_public_path__ + "static/media/vgu-login-banner2.68b2e3f1.jpg";